// extracted by mini-css-extract-plugin
export default {"self":"PastoralVisitLayout-module--self--4vCeP","footerWrapper":"PastoralVisitLayout-module--footerWrapper--Xt-78"};